import axios from "infra/http";
import { useQuery } from "react-query";
import { UnidadeResponse } from "./typings/unidade";

function useUnidade(id?: string) {
  return useQuery(
    `/v1/unidades/${id}`,
    async () => {
      const res = await axios.get<UnidadeResponse>(`/v1/unidades/${id}`);

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useUnidade;
